/**
 * BUR-172: Section rendering para añadir filter.v.availability=1 sin redirección.
 * Evita el flash de contenido incorrecto usando fetch + replace en lugar de redirect.
 * Search & Discovery indexa valores de variantes, no disponibilidad.
 */
(function () {
  if (
    typeof window === "undefined" ||
    !window.location.pathname.includes("/collections/")
  )
    return;

  const params = new URLSearchParams(window.location.search);
  if (params.has("filter.v.availability")) return;

  params.set("filter.v.availability", "1");

  const productGrid = document.getElementById("product-grid");
  const sectionId =
    productGrid?.dataset?.id ||
    document.getElementById("main-collection-filters")?.dataset?.id;
  if (!sectionId) return;

  const collectionEl = document.querySelector(
    "#ProductGridContainer .collection",
  );
  if (collectionEl) collectionEl.classList.add("loading");

  const searchParams = params.toString().replace(/%2C/g, ",");
  const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;

  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const parsedHTML = new DOMParser().parseFromString(html, "text/html");

      const newProductGrid = parsedHTML.getElementById("ProductGridContainer");
      if (newProductGrid) {
        const container = document.getElementById("ProductGridContainer");
        if (container) {
          container.innerHTML = newProductGrid.innerHTML;
          container
            .querySelectorAll(".scroll-trigger")
            .forEach((el) => el.classList.add("scroll-trigger--cancel"));
        }
      }

      const newFilters = parsedHTML.getElementById("main-collection-filters");
      if (newFilters) {
        const filters = document.getElementById("main-collection-filters");
        if (filters) filters.innerHTML = newFilters.innerHTML;
      }

      const countEl = parsedHTML.getElementById("ProductCount");
      if (countEl) {
        const count = document.getElementById("ProductCount");
        const countDesktop = document.getElementById("ProductCountDesktop");
        if (count) count.innerHTML = countEl.innerHTML;
        if (countDesktop) countDesktop.innerHTML = countEl.innerHTML;
      }

      [".active-facets-mobile", ".active-facets-desktop"].forEach(
        (selector) => {
          const newEl = parsedHTML.querySelector(selector);
          if (!newEl) return;
          document.querySelectorAll(selector).forEach((currEl) => {
            currEl.innerHTML = newEl.innerHTML;
          });
        },
      );

      [".mobile-facets__open", ".mobile-facets__count"].forEach((selector) => {
        const newEl = parsedHTML.querySelector(selector);
        const currEl = document.querySelector(selector);
        if (newEl && currEl) currEl.innerHTML = newEl.innerHTML;
      });

      const menuDrawer = document
        .getElementById("FacetFiltersFormMobile")
        ?.closest("menu-drawer");
      if (menuDrawer?.bindEvents) menuDrawer.bindEvents();

      if (typeof initializeScrollAnimationTrigger === "function") {
        initializeScrollAnimationTrigger(html);
      }

      history.replaceState(
        { searchParams },
        "",
        `${window.location.pathname}?${searchParams}`,
      );

      if (typeof FacetFiltersForm !== "undefined") {
        FacetFiltersForm.searchParamsInitial = searchParams;
        FacetFiltersForm.searchParamsPrev = searchParams;
      }

      document.dispatchEvent(new CustomEvent("facet:rendered"));
    })
    .catch(() => {
      params.set("filter.v.availability", "1");
      window.location.replace(
        `${window.location.pathname}?${params.toString()}`,
      );
    })
    .finally(() => {
      const collection = document.querySelector(
        "#ProductGridContainer .collection",
      );
      if (collection) collection.classList.remove("loading");
      document
        .querySelectorAll(
          ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
        )
        .forEach((s) => s.classList.add("hidden"));
      const countContainer = document.getElementById("ProductCount");
      const countDesktop = document.getElementById("ProductCountDesktop");
      if (countContainer) countContainer.classList.remove("loading");
      if (countDesktop) countDesktop.classList.remove("loading");
    });
})();
